import type { SxProps, Theme } from "@mui/material";
import { IconButton } from "@mui/material";
import FavoriteStarIcon from "@entrilia/shared/components/FavoriteStarIcon";

interface Props {
  isFavorite: boolean;
  className?: string;
  sx?: SxProps<Theme>;
  onClick: () => void;
}

const ArtifactFavoriteButton = ({ isFavorite, className, sx, onClick }: Props) => (
  <IconButton
    className={className}
    aria-label={isFavorite ? "Remove from favorites" : "Add to favorites"}
    aria-pressed={isFavorite}
    onClick={onClick}
    sx={sx}
  >
    <FavoriteStarIcon isFavorite={isFavorite} />
  </IconButton>
);

export default ArtifactFavoriteButton;
